import { IHomeArticleData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IContentItemArticle } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class HomeArticle {
  id: number | undefined;
  parrentType: string;
  title: string;
  description: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  imgUrl: string;
  articleType: string | null;
  dateCreated: number | string | undefined;
  seoURL?: string;

  constructor() {
    this.id = undefined;
    this.parrentType = '';
    this.title = '';
    this.description = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.imgUrl = '';
    this.articleType = null;
    this.dateCreated = '';
    this.seoURL = '';
  }

  static mappingObject(_obj: IHomeArticleData): IContentItemArticle {
    let obj = Object.assign(new HomeArticle(), _obj);
    obj.id = _obj.ID || -1;
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.title = _obj.Title ? _obj.Title : '';
    obj.description = _obj.Description ? _obj.Description : '';
    obj.likeCount = _obj.LikeCount ? _obj.LikeCount : 0;
    obj.replyCount = _obj.ReplyCount ? _obj.ReplyCount : 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.imgUrl = _obj.ImgUrl ? _obj.ImgUrl : '';
    obj.articleType = _obj.ArticleType ? _obj.ArticleType : null;
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.seoURL = _obj.SEOUrl || '';
    obj = utils.cleanObjectKeys(Object.keys(new HomeArticle()), obj);

    return obj;
  }

  static mappingObjects(_data: IHomeArticleData[]): IContentItemArticle[] {
    return _data.map(item => HomeArticle.mappingObject(item));
  }
}
